(() => {
  const formatPrices = () => {
    document.querySelectorAll('[data-category-price]').forEach(element => {
      const amount = Number(element.dataset.categoryPrice);
      if (!Number.isFinite(amount) || amount < 0) return;
      try {
        const locale = element.dataset.locale.startsWith('fr') ? 'fr-CA' : 'en-CA';
        element.textContent = new Intl.NumberFormat(locale, { style: 'currency', currency: element.dataset.currency }).format(amount / 100);
      } catch {}
    });
  };
  formatPrices();
  document.addEventListener('shopify:section:load', formatPrices);
})();
